import { render, staticRenderFns } from "./set-coord.vue?vue&type=template&id=9e4aad00&"
import script from "./set-coord.vue?vue&type=script&lang=js&"
export * from "./set-coord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports